import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({
	children,
	requireAdmin = false,
	requireGestor = false,
	requireAdminOrContador = false,
	requireGestorOrContador = false,
}) => {
	const { user, loading, isAdmin, isGestor, isContador, isAdminOrContador } = useAuth();

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
					<p className="mt-4 text-gray-600">Cargando...</p>
				</div>
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	const denyAccess = (
		<div className="min-h-screen flex items-center justify-center">
			<div className="text-center">
				<h2 className="text-2xl font-bold text-gray-900">Acceso Denegado</h2>
				<p className="mt-2 text-gray-600">No tienes permisos para acceder a esta página.</p>
			</div>
		</div>
	);

	if (requireAdmin && !isAdmin()) return denyAccess;
	if (requireGestor && !isGestor()) return denyAccess;
	if (requireAdminOrContador && !isAdminOrContador()) return denyAccess;
	if (requireGestorOrContador && !isGestor() && !isContador()) return denyAccess;

	return children;
};

export default ProtectedRoute;

